import { Component, inject, Signal } from '@angular/core';
import { JavaClass } from '../models/java-class.class';
import { UmlService } from '../../services/uml.service';
import { UmlCanvasComponent } from '../uml-canvas/uml-canvas.component';

@Component({
  selector: 'app-display-uml',
  standalone: true,
  imports: [UmlCanvasComponent],
  templateUrl: './display-uml.component.html',
  styleUrl: './display-uml.component.scss',
})
export class DisplayUmlComponent {
  umlService = inject(UmlService);
  javaClass: Signal<JavaClass> = this.umlService.getJavaClass();
}
